import { CoveoCommerceState } from "@DSG/Store/Data/CoveoCommerceState";
import { RecommendationInfo, UpdatedProductQtyInfo } from "@DSG/Type/CoveoModels";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: CoveoCommerceState = {
    CoveoIsInitializing: false,
    CoveoIsInitialized: false,
    CoveoIsConfiguring: false,
    ProductListingController: null,
    SearchController: null,
    SearchBoxController: null,
    MainCoveoProductController: null,
    // BreadcrumbManagerController: null,
    RecentQueriesController: null,
    RecommendationsController: null,
    InstantProductsController: null,
    CartController: null,
    ProductViewController: null,
    ProductListingState: null,
    SearchBoxState: null,
    SearchState: null,
    PaginationState: null,
    SortController: null,
    SortState: null,
    // BreadcrumbManagerState: null,
    RecentQueriesState: null,
    RecommendationsState: null,
    InstantProductsState: null,
    CartState: null,
    Context: null,
    SearchInputQuery: "",
    LoadingRealTimePricing: false,
    IsPlpPage: false,
    ShowMoreFacetSelections: () => { },
    RedirectTriggerController: null,
    RedirectTriggerState: null,
    // FacetManagerState: null,
    QueryParamWhiteList: "",
    UnSubCoveoUIConfigs: () => { },
    SelectedSuggestionIndex: 0,
    UpdatedProductQtyInfoList: [],
    BreadcrumbManagerController: null,
    BreadcrumbManagerState: null,
    FacetManagerState: null,
    RecommendationsListState: [],
    FilterSuggestionsController: null,
    FilterSuggestionsState: null,
    IsLoadingUi: false
}

export const DISPATCH_COVEO_IS_INITIALIZING = "Coveo/DispatchCoveoIsInitializing";
export const DISPATCH_PRODUCT_LISTING_CONTROLLER = "Coveo/DispatchProductListingController";
export const DISPATCH_UPDATE_PRODUCT_LISTING_STATE = "Coveo/DispatchUpdateProductListingState";
export const DISPATCH_COVEO_IS_INITIALIZED = "Coveo/DispatchCoveoIsInitialized";
export const DISPATCH_COVEO_IS_CONFIGURING = "Coveo/DispatchCoveoIsConfiguring";
export const DISPATCH_MAIN_COVEO_PRODUCT_CONTROLLER = "Coveo/DispatchMainCoveoProductController";
export const DISPATCH_UPDATE_QUERY_PARAM_WHITE_LIST = "Coveo/DispatchUpdateQueryParamWhiteList";
export const DISPATCH_UPDATE_UN_SUB_COVEO_UI_CONFIG = "Coveo/DispatchUpdateUnSubCoveoUIConfig";
export const DISPATCH_CONTEXT = "Coveo/DispatchContext";
export const DISPATCH_SEARCH_BOX_CONTROLLER = "Coveo/DispatchSearchBoxController";
export const DISPATCH_UPDATE_SEARCH_BOX_STATE = "Coveo/DispatchUpdateSearchBoxState";
export const DISPATCH_RESET_SEARCH_INPUT_QUERY = "Coveo/DispatchResetSearchInputQuery";
export const DISPATCH_SET_SEARCH_INPUT_QUERY = "Coveo/DispatchSetSearchInputQuery";
export const DISPATCH_UPDATE_SEARCH_STATE = "Coveo/DispatchUpdateSearchState";
export const DISPATCH_UPDATE_INSTANT_PRODUCTS_STATE = "Coveo/DispatchUpdateInstantProductsState";
export const DISPATCH_INSTANT_PRODUCTS_CONTROLLER = "Coveo/DispatchInstantProductsController";
export const DISPATCH_RECENT_QUERIES_CONTROLLER = "Coveo/DispatchRecentQueriesController";
export const DISPATCH_UPDATE_RECENT_QUERIES_STATE = "Coveo/DispatchUpdateRecentQueriesState";
export const DISPATCH_SELECTED_SUGGESTION_INDEX_STATE = "Coveo/DispatchSelectedSuggestionIndexState"
export const DISPATCH_SEARCH_CONTROLLER = "Coveo/DispatchSearchController";
export const DISPATCH_UPDATE_FACET_MANAGER_STATE = "Coveo/DispatchUpdateFacetManagerState";
export const DISPATCH_PRODUCTINFO = "Coveo/DispatchProductInfo";
export const DISPATCH_BREADCRUMB_MANAGER_CONTROLLER = "Coveo/DispatchBreadcrumbManagerController";
export const DISPATCH_UPDATE_BREADCRUMB_MANAGER_STATE = "Coveo/DispatchUpdateBreadcrumbManagerState";
export const DISPATCH_SORT_CONTROLLER = "Coveo/DispatchSortController";
export const DISPATCH_UPDATE_SORT_STATE = "Coveo/DispatchUpdateSortState";
export const DISPATCH_UPDATE_PAGINATION_STATE = "Coveo/DispatchUpdatePaginationState";
export const DISPATCH_CART_CONTROLLER = "Coveo/DispatchCartController";
export const DISPATCH_UPDATE_CART_STATE = "Coveo/DispatchUpdateCartState";
export const DISPATCH_REDIRECTION_TRIGGER_CONTROLLER = "Coveo/DispatchRedirectionTriggerController";
export const DISPATCH_UPDATE_REDIRECTION_TRIGGER_STATE = "Coveo/DispatchUpdateRedirectionTriggerState";
export const DISPATCH_PRODUCT_VIEW_CONTROLLER = "Coveo/DispatchProductViewController";
export const DISPATCH_RECOMMENDATIONS_CONTROLLER = "Coveo/DispatchRecommendationsController";
export const DISPATCH_RECOMMENDATIONS_STATE = "Coveo/DispatchRecommendationsState";
export const DISPATCH_RECOMMENDATIONS_LIST_STATE = "Coveo/DispatchRecommendationsListState";
export const DISPATCH_FILTER_SUGGESTIONS_CONTROLLER = "Coveo/DispatchFilterSuggestionsController";
export const DISPATCH_FILTER_SUGGESTIONS_STATE = "Coveo/DispatchUpdateFilterSuggestionsState";
export const DISPATCH_ISLOADING_UI_STATE = "Coveo/DispatchIsLoadingUiState";

const reducer = {
    [DISPATCH_COVEO_IS_INITIALIZING]: (
        draft: Draft<CoveoCommerceState>,
        action: { isInitializing: boolean }
    ) => {
        // console.log("DispatchCoveoIsInitializing >>", action);
        draft.CoveoIsInitializing = action.isInitializing;
    },
    [DISPATCH_COVEO_IS_INITIALIZED]: (
        draft: Draft<CoveoCommerceState>,
        action: { isInitialized: boolean }
    ) => {
        // console.log("DispatchCoveoIsInitialized >>", action);
        draft.CoveoIsInitialized = action.isInitialized;
    },
    [DISPATCH_PRODUCT_LISTING_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { productsListing: CoveoCommerceState["ProductListingController"] }
    ) => {
        // console.log("DispatchProductListingController >>", action);
        draft.ProductListingController = action.productsListing;
    },
    [DISPATCH_UPDATE_PRODUCT_LISTING_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["ProductListingState"] }
    ) => {
        // console.log("DispatchUpdateProductListingState >>", action);
        draft.ProductListingState = action.state;
    },
    [DISPATCH_COVEO_IS_CONFIGURING]: (
        draft: Draft<CoveoCommerceState>,
        action: { isConfiguring: boolean }
    ) => {
        // console.log("DispatchCoveoIsConfiguring >>", action);
        draft.CoveoIsConfiguring = action.isConfiguring;
    },
    [DISPATCH_MAIN_COVEO_PRODUCT_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { controller: CoveoCommerceState["MainCoveoProductController"] }
    ) => {
        // console.log("DispatchMainCoveoProductController >>", action);
        draft.MainCoveoProductController = action.controller;
    },
    [DISPATCH_UPDATE_QUERY_PARAM_WHITE_LIST]: (
        draft: Draft<CoveoCommerceState>,
        action: { queryWhitelist: string }
    ) => {
        // console.log("DispatchUpdateQueryParamWhitelist >>", action);
        draft.QueryParamWhiteList = action.queryWhitelist;
    },
    [DISPATCH_UPDATE_UN_SUB_COVEO_UI_CONFIG]: (
        draft: Draft<CoveoCommerceState>,
        action: { unSub: () => void }
    ) => {
        // console.log("DispatchUpdateUnSubCoveoUIConfig >>", action);
        draft.UnSubCoveoUIConfigs = action.unSub;
    },
    [DISPATCH_CONTEXT]: (
        draft: Draft<CoveoCommerceState>,
        action: { context: CoveoCommerceState["Context"] }
    ) => {
        // console.log("DispatchContext >>", action);
        draft.Context = action.context;
    },
    [DISPATCH_SEARCH_BOX_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { coveoSearchBox: CoveoCommerceState["SearchBoxController"] }
    ) => {
        // console.log("DispatchSearchBoxController >>", action);
        draft.SearchBoxController = action.coveoSearchBox;
    },
    [DISPATCH_UPDATE_SEARCH_BOX_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["SearchBoxState"] }
    ) => {
        // console.log("DispatchUpdateSearchBoxState >>", action);
        draft.SearchBoxState = action.state;
    },
    [DISPATCH_FILTER_SUGGESTIONS_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { filterSuggestionsGenerator: CoveoCommerceState["FilterSuggestionsController"] }
    ) => {
        draft.FilterSuggestionsController = action.filterSuggestionsGenerator;
    },
    [DISPATCH_FILTER_SUGGESTIONS_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["FilterSuggestionsState"] }
    ) => {
        draft.FilterSuggestionsState = action.state;
    },
    [DISPATCH_RESET_SEARCH_INPUT_QUERY]: (
        draft: Draft<CoveoCommerceState>
    ) => {
        // console.log("DispatchResetSearchInputQuery >>");
        draft.SearchInputQuery = "";
    },
    [DISPATCH_SET_SEARCH_INPUT_QUERY]: (
        draft: Draft<CoveoCommerceState>,
        action: { query: string }
    ) => {
        // console.log("DispatchSetSearchInputQuery >>", action);
        draft.SearchInputQuery = action.query;
    },
    [DISPATCH_UPDATE_SEARCH_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["SearchState"] }
    ) => {
        // console.log("DispatchUpdateSearchState >>", action);
        draft.SearchState = action.state;
    },
    [DISPATCH_UPDATE_INSTANT_PRODUCTS_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["InstantProductsState"] }
    ) => {
        // console.log("DispatchUpdateInstantProductsState >>", action);
        draft.InstantProductsState = action.state;
    },
    [DISPATCH_INSTANT_PRODUCTS_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { instantProduct: CoveoCommerceState["InstantProductsController"] }
    ) => {
        // console.log("DispatchInstantProductsController >>", action);
        draft.InstantProductsController = action.instantProduct;
    },
    [DISPATCH_RECENT_QUERIES_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { recentQueries: CoveoCommerceState["RecentQueriesController"] }
    ) => {
        // console.log("DispatchRecentQueriesController >>", action);
        draft.RecentQueriesController = action.recentQueries;
    },
    [DISPATCH_UPDATE_RECENT_QUERIES_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["RecentQueriesState"] }
    ) => {
        // console.log("DispatchUpdateRecentQueriesState >>", action);
        draft.RecentQueriesState = action.state;
    },
    [DISPATCH_SELECTED_SUGGESTION_INDEX_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { query: number  }
    ) => {
        // console.log("DispatchUpdateRecentQueriesState >>", action);
        draft.SelectedSuggestionIndex = action.query;
    },
    [DISPATCH_SEARCH_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { coveoSearch: CoveoCommerceState["SearchController"] }
    ) => {
        // console.log("DispatchSearchController >>", action);
        draft.SearchController = action.coveoSearch;
    },
    [DISPATCH_PRODUCTINFO]: (
        draft: Draft<CoveoCommerceState>,
        action: { query: UpdatedProductQtyInfo  }
    ) => {
        // draft.UpdatedProductQtyInfo = action.query;
        const { productId, qtyOrdered } = action.query;
        const existingProduct = (draft.UpdatedProductQtyInfoList || []).find(product => product.productId === productId);


        if (existingProduct) {
            // Update the quantity of the existing product
            existingProduct.qtyOrdered = qtyOrdered;
        } else {
            // Add the new product to the list
            draft.UpdatedProductQtyInfoList.push({ productId, qtyOrdered });
        }
    },
    [DISPATCH_SORT_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { sort: CoveoCommerceState["SortController"] }
    ) => {
        // console.log("DispatchSortController >>", action);
        draft.SortController = action.sort;
    },
    [DISPATCH_UPDATE_SORT_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["SortState"] }
    ) => {
        // console.log("DispatchSortState >>", action);
        draft.SortState = action.state;
    },
    [DISPATCH_UPDATE_PAGINATION_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["PaginationState"] }
    ) => {
        // console.log("DispatchPaginationState >>", action);
        draft.PaginationState = action.state;
    },
    [DISPATCH_UPDATE_FACET_MANAGER_STATE]: (
      draft: Draft<CoveoCommerceState>,
      action: { state: CoveoCommerceState["FacetManagerState"] }
    ) => {
        // console.log("DispatchFacetManagerState >>", action);
        draft.FacetManagerState = action.state;
    },
    [DISPATCH_BREADCRUMB_MANAGER_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { breadcrumbManager: CoveoCommerceState["BreadcrumbManagerController"] }
    ) => {
        // console.log("DispatchBreadcrumbManagerController >>", action);
        draft.BreadcrumbManagerController = action.breadcrumbManager;
    },
    [DISPATCH_UPDATE_BREADCRUMB_MANAGER_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["BreadcrumbManagerState"] }
    ) => {
        // console.log("DispatchBreadcrumbManagerState >>", action);
        draft.BreadcrumbManagerState = action.state;
    },
    [DISPATCH_CART_CONTROLLER]: (
      draft: Draft<CoveoCommerceState>,
      action: { cart: CoveoCommerceState["CartController"] }
    ) => {
        // console.log("DispatchCartController >>", action);
        draft.CartController = action.cart;
    },
    [DISPATCH_UPDATE_CART_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["CartState"] }
    ) => {
        // console.log("DispatchUpdateCartState >>", action);
        draft.CartState = action.state;
    },
    [DISPATCH_REDIRECTION_TRIGGER_CONTROLLER]: (
      draft: Draft<CoveoCommerceState>,
      action: { redirectTrigger: CoveoCommerceState["RedirectTriggerController"] }
    ) => {
        // console.log("DispatchRedirectionTrigger >>", action);
        draft.RedirectTriggerController = action.redirectTrigger;
    },
    [DISPATCH_UPDATE_REDIRECTION_TRIGGER_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["RedirectTriggerState"] }
    ) => {
        // console.log("DispatchUpdateRedirectionTriggerState >>", action);
        draft.RedirectTriggerState = action.state;
    },
    [DISPATCH_PRODUCT_VIEW_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { productView: CoveoCommerceState["ProductViewController"] }
    ) => {
        // console.log("DispatchProductViewController >>", action);
        draft.ProductViewController = action.productView;
    },
    [DISPATCH_RECOMMENDATIONS_CONTROLLER]: (
        draft: Draft<CoveoCommerceState>,
        action: { recommendation: CoveoCommerceState["RecommendationsController"] }
    ) => {
        // console.log("DispatchRecommendationsController >>", action);
        draft.RecommendationsController = action.recommendation;
    },
    [DISPATCH_RECOMMENDATIONS_LIST_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: RecommendationInfo }
    ) => {
        // console.log("DispatchRecommendationsState >>", action);
        const { recommendationState,slotId } = action.state;
        // draft.RecommendationsState[slotId] = recommendationState;
        const existingIndex = draft.RecommendationsListState.findIndex(
            (entry) => entry.slotId === slotId
          );
         // console.log("DispatchRecommendationsState >>", recommendationState);
          if (recommendationState && recommendationState.products.length > 0) {
          if (existingIndex !== -1) {
            // Update the existing entry
            draft.RecommendationsListState[existingIndex].recommendationState = recommendationState;
          } else {
            // Add a new entry
            draft.RecommendationsListState.push({ recommendationState, slotId });
          }
        }
    },
    [DISPATCH_RECOMMENDATIONS_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { state: CoveoCommerceState["RecommendationsState"] }
    ) => {
        // console.log("DispatchRecommendationsState >>", action);
        draft.RecommendationsState = action.state;
    },
    [DISPATCH_ISLOADING_UI_STATE]: (
        draft: Draft<CoveoCommerceState>,
        action: { query: boolean  }
    ) => { 
        draft.IsLoadingUi = action.query;
    }
}

const customDataReducer = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).DSGGlobalData = customDataReducer;

type CustomReducers = {
    DSGGlobalData: typeof customDataReducer;
};

export type CoveoActions = Parameters<CustomReducers[keyof CustomReducers]>[1] | AnyAction;